<template>
  <div :class="['check-list-flags__flag is-opl', response['payment-status']]">
    ОПЛ
  </div>
</template>

<script>
export default {
  name: 'PaymentStatus',
  props: {
    response: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="sass" scoped>
.check-list-flags__flag.danger
  color: #f00
.check-list-flags__flag.warning
  color: #ffb800
.check-list-flags__flag.success
  color: #00bf40
</style>
